/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* EFS snapshot properties for native AWS Backup snapshots.
*/
export class EfsSnapshotProperties {
  /**
  * AWS Backup recovery point ARN.
  */
  'recoveryPointArn'?: string;
  /**
  * AWS Backup vault name where the backup is stored.
  */
  'backupVaultName'?: string;
  /**
  * AWS region where the backup is stored.
  */
  'region'?: string;
  /**
  * AWS account ID where the backup is stored.
  */
  'sourceAccountId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "recoveryPointArn",
      "baseName": "recoveryPointArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "backupVaultName",
      "baseName": "backupVaultName",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceAccountId",
      "baseName": "sourceAccountId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EfsSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

